import React, { useEffect, useMemo, useState } from 'react'
import PageHeadContainer from '../../basic-component/PageHeadContainer'
import styled from 'styled-components'
import DatatTable from '../../basic-component/Table'
import { t } from 'i18next'
import { apiHostUrl, discardFeedbackURL, getOldFeedbackSPOCUrl, newFeedbackListSPOCUrl, unTagOldFeedbackReceipt, updateFeedbackUserURL } from '../../../../constants/constants'

import useAxiosFetchData from '../../../hooks/useAxiosFetchData'
import { useSelector } from 'react-redux'
import TagContainer from '../../basic-component/FeedbackListStatusTag'
import { light_theme_bg_grey } from '../../../../constants/constants'
import { ReactComponent as addReceipt } from '../../../../assets/SVG/addReceipt.svg'
import { ReactComponent as discardIcon } from '../../../../assets/SVG/discardFeedbackIcon.svg'
import IconWrapper from '../../basic-component/IconWrapper'
import { formattedMonth, formattedDate } from '../../basic-component/DateUtils'
import { ActionButtonGroup, FormContainer, FormRow, GridContainer, HorizontalContainer, SmallBottomNegativeMargin } from '../../../../styles/styled-component'
// import ViewFeedBackDetails from '../../basic-component/form-component/feedback-form/ViewFeedbackDetails'
import FeedBackDetails from '../../pages/feedbackDetails/FeedBackDetails'
import API_Routes from '../../../../constants/api-routes'
import ViewFeedbackDetails from '../../pages/feedbackDetails/ViewFeedbackDetails'
import TextLabel from '../../basic-component/TextLabel'
import Dropdown from '../../basic-component/Dropdown'
import { isEmptyObject } from 'document/lib/lang'
import DatePickerComponent from '../../basic-component/DatePickerComponent'
import PluginSnackbar from '../../basic-component/Snackbar'
import SmallFormSubmitButton from '../../basic-component/SmallFormSubmitButton'
import TagOldFeedback from '../../basic-component/feedback/TagOldFeedback'
import SLAContainer from '../../basic-component/SLAContainer'
import ReadOnlyTextField from '../../basic-component/ReadOnlyTextField'
import FeedbackClosure from '../../basic-component/form-component/feedback-form/FeedbackClosure'
import ViewFeedbackDetailsForClose from '../../pages/feedbackDetails/ViewFeedbackDetailsForClose'
import UntagFeedbackDialog from '../../basic-component/UntagFeedbackDialog'

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { CardBody } from 'react-bootstrap'
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import moment from "moment";


export default function AddReciept({ path, fdHandler, isUsedWithModal = false, dataUsedWithModal, usedForReopen, onModalCloseHandler, snackBarSwitch, snackMsg, parentModalOnClose, scoopDataForChild, modalSwitchHandler }) {

    const [spocDeptID, setSpocDeptID] = useState({ id: useSelector(state => state.role.userCurrRole.department.id) });
    const [spocDepartAttrDeptID, setSpocDepartAttrDeptID] = useState({ serviceId: useSelector(state => state.role.userCurrRole.department.id) });
    const { csrfToken } = useSelector(state => state.csrf);
    const { homeLink } = useSelector((state) => state.role);
    const [headers, setHeaders] = useState({
        'Accept': '*/*',
        'X-Csrf-Token': csrfToken,
        'Content-Type': 'application/json',
    })
    const [oldFeedbacks, setOldFeedbacks] = useState([]);
    const [rowsData, setRowsData] = useState([]);
    const [openAddReceipt, setOpenAddReceipt] = useState(false);
    const [selectedRow, setSelectedRow] = useState([]);
    const [receiptFetchPayload, setReceiptFetchPayload] = useState({ departmentId: "", feedbackId: "", status: "" });

    const [receiptResponse, setReceiptResponse] = useState(null);
    const [isDiscardAllowed, setIsDiscardAllowed] = useState(false);

    const [attrList, setAttrList] = useState(null);
    const [readOnlyAttr, setreadOnlyAttr] = useState(false);
    const [attributeMasterValueList, setAttributeMasterValueList] = useState([]);
    const [departmentAttrChanged, setdepartmentAttrChanged] = useState(false);
    const [canSubmitDepartmentAttribute, setCanSubmitDepartmentAttribute] = useState(false);
    const [departmentAttribute, setDepartmentAttribute] = useState({ "id": -1, "attributeList": [] });
    const [receivedOldFeedback, setReceivedOldFeedback] = useState(false);
    const [canTagOF, setCanTagOF] = useState(0);
    const { deptId } = useSelector(state => state.role.userCurrRole.department.id);
    const [tagFeedbackPayload, setTagfeedbackpayload] = useState({ departmentId: "", feedbackId: "", feedback: {} });
    const [isOldFeedbackListReady, setIsOldFeedbackListReady] = useState(false);
    const [isTagFeedbackReady, setIsTagFeedbackReady] = useState(false);
    const [tagUntag, setTagUntag] = useState(0); //0 for nothing, 1 for tag, 2 for untag
    const [unTagfeedbackPayload, setUnTagfeedbackPayload] = useState({ departmentId: "", feedbackId: "", feedback: {} });
    const [deptAtrSwtich, setDeptAtrSwtich] = useState(false);
    const [addReceiptSnackbarSwitch, setAddReceiptSnackbarSwitch] = useState(false);
    const [saveDepartmentAttributeSnack, setSaveDepartmentAttributeSnack] = useState(false);
    const [isDeptAttrSet, setIsDeptAttrSet] = useState(true);
    const [disableReceiptView, setDisableReceiptView] = useState(false);
    // const [searchEmail, setSearchEmail] = useState("");
    const [userList, setUserList] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [formData, setFormData] = useState({
        "departmentId": spocDeptID.id,
        "feedbackId": "",
        "receiptTargetId": ""
    });
    const [itemData, setItemData] = useState({});
    const [countAttributeChange, setCountAttributeChange] = useState(0);
    const [isNumberOfDepartmentAttributesEven, setIsNumberOfDepartmentAttributesEven] = useState(false);
    const toggleAddReceiptSnackbarSwitch = () => {
        snackBarSwitch(!snackBarSwitch);
        onModalCloseHandler();
    }
    const [snackbarMessage, setSnackbarMessage] = useState("");


    const [discardFeedbackPayload, setDiscardFeedbackPayload] = useState(null);
    const [openDiscardDialog, setOpenDiscardDialog] = useState(false);
    const [discardFeedbackComment, setDiscardFeedbackComment] = useState(null);
    const [readyToDiscard, setReadyToDiscard] = useState(false);
    const [discardFeedbackSuccessSnackbarSwitch, setDiscardFeedbackSuccessSnackbarSwitch] = useState(false);

    const [submitting, setSubmitting] = useState(false);
    const [attrValList, setAttrValList] = useState([]);

    const { response: newFeedbackListResponse } = useAxiosFetchData({
        url: newFeedbackListSPOCUrl,
        method: 'post',
        body: spocDeptID,
        headers: headers,
        onLoad: isUsedWithModal ? false : true
    })

    const { fetchData: fetchDetailsforReceiptSPOCURL } = useAxiosFetchData({
        url: API_Routes.getDetailsforReceiptSPOCURL,
        method: 'post',
        body: receiptFetchPayload,
        headers: headers,
        onLoad: false,
    })
    const { fetchData: updateFeedbackUser } = useAxiosFetchData({
    url: `${apiHostUrl}${homeLink}${updateFeedbackUserURL}`,
    method: 'post',
    body: {
        feedbackId: receiptResponse?.receiptDetails?.feedback?.feedbackId,
        bidderId: selectedUserId
    },
    headers: headers,
    onLoad: false,
    })
    const { fetchData: fetchDepartmentAttributes } = useAxiosFetchData({
        url: API_Routes.getDepartmentAtributeMapSPOC,
        method: 'post',
        body: spocDepartAttrDeptID,
        headers: headers,
        onLoad: false
    })
    const { fetchData: saveDepartmentAttribute } = useAxiosFetchData({
        url: API_Routes.saveFeedbackDetailsSPOC,
        method: 'post',
        body: { "id": receiptResponse?.receiptDetails?.feedback?.feedbackId, "attributeList": Object.values(
                departmentAttribute?.attributeList?.reduce((acc, obj) => {
                    if (!obj || obj.attributeId == null) return acc;
                    acc[obj.attributeId] = obj; 
                    return acc;
                }, {})
                )},
        headers: headers,
        onLoad: false
    })
    const { fetchData: tagFeedback } = useAxiosFetchData({
        url: API_Routes.spocTagOldFeedbackReceipt,
        method: 'post',
        body: tagFeedbackPayload,
        headers: headers,
        onLoad: false
    })
    const { fetchData: untagFeedback } = useAxiosFetchData({
        url: `${apiHostUrl}${homeLink}${unTagOldFeedbackReceipt}`,
        method: 'post',
        body: unTagfeedbackPayload,
        headers: headers,
        onLoad: false
    })
    const { fetchData: discardFeedback } = useAxiosFetchData({
        url: `${apiHostUrl}${homeLink}${discardFeedbackURL}`,
        method: 'post',
        body: discardFeedbackPayload,
        headers: headers,
        onLoad: false
    })


    const handleClose = (data) => {

    }


    const tableStyles = {
        width: " 100%",
        height: "auto",
        minWidth: "0"
    }

    const columnData = useMemo(
        () => [

            {
                accessorKey: 'sl_no',
                header: t('label.new.feedbacklist.SLNo'),
                size: 120,
            },
            {
                accessorKey: 'feedback_code',
                header: t('label.new.feedbacklist.feedbackCdoe'),
            },
            {
                accessorKey: 'feedback_desc',
                header: t('label.new.feedbacklist.Description'),
            },
            {
                accessorKey: 'org',
                header: t('label.new.feedbacklist.Organization'),
            },
            {
                accessorKey: 'date',
                header: t('label.new.feedbacklist.DateOfFeedback'),
            },
            {
                accessorKey: 'status',
                header: t('label.new.feedbacklist.Status'),
                size: 100,
            },
            {
                accessorKey: 'action',
                header: t('label.new.feedbacklist.Action'),
                size: 100,
            }
        ],
        [t],
    );
    const handlerClick = (rfPayload) => {
        console.log(rfPayload);
        setOpenAddReceipt(true);
        setReceiptFetchPayload(rfPayload);
    }
     
    useEffect(() => {
        setAttrValList(attrValList ?? []);
    }, [attrValList]); 

  /*  const handleClientChange = (payload, keyIdentifier) => {
        debugger;
        console.log("Handle Client Change", payload, keyIdentifier);
              
        setAttrValList(prev => {
            Object.freeze(prev);
            return prev.map(item => {
                Object.freeze(item);
                return item.attributeId === keyIdentifier
                ? { ...item, attributeVal: payload?.attributeVal ?? ''}
                : item;
            });
        });

            setDepartmentAttribute((prev) => {
                return { "id": receiptResponse.receiptDetails.feedback.feedbackId, attributeList: [...prev.attributeList, payload] };
            });
        
        //console.log("payload----" + payload);
        setCountAttributeChange((prev) => (prev + 1));
        let numberOfMandatoryAttributes = 0;
        Object.values(attrList).forEach((attribute, index) => {
            if (attribute.mandatory === "Y") {
                numberOfMandatoryAttributes++;
            }
        })
        if (countAttributeChange + 1 === numberOfMandatoryAttributes) setCanSubmitDepartmentAttribute(true);
        
    }*/

  const handleClientChange = (payload, keyIdentifier) => {
    debugger;
    console.log("Handle Client Change", payload, keyIdentifier);

    const value =
        payload?.attributeVal !== undefined
            ? payload.attributeVal
            : payload ?? '';

    // 🔹 Get full attribute definition from master list
    const baseAttribute = Object.values(attrList || {}).find(
    attr => attr.attributeId === keyIdentifier
    );


    // 🔹 Get existing saved department attribute (to preserve departmentAttributeId)
    const existingAttribute = departmentAttribute?.attributeList?.find(
        item => item.attributeId === keyIdentifier
    );

    if (!baseAttribute) return; // safety check

    // 🔥 Build FULL object required by backend
    const updatedAttribute = {
        attributeId: baseAttribute.attributeId,
        attributeName: baseAttribute.attributeName,
        attributeType: baseAttribute.attributeType,
        attributeVal: value,
        departmentAttributeId:
            existingAttribute?.departmentAttributeId ??
            baseAttribute.departmentAttributeId ??
            null,
        departmentAttributeValId:
        payload?.departmentAttributeValId ??
        existingAttribute?.departmentAttributeValId ??
        null,
        isspoceditenabled: baseAttribute.isspoceditenabled,
        itemIndex: baseAttribute.itemIndex,
        mandatory: baseAttribute.mandatory,
    };

    // Update attrValList (for UI validation)
    setAttrValList(prev =>
        prev.map(item =>
            item.attributeId === keyIdentifier
                ? { ...item, attributeVal: value }
                : item
        )
    );

    // Replace instead of duplicate push
    setDepartmentAttribute(prev => ({
        id: receiptResponse?.receiptDetails?.feedback?.feedbackId,
        attributeList: [
            ...(prev?.attributeList || []).filter(
                item => item.attributeId !== keyIdentifier
            ),
            updatedAttribute
        ],
    }));

    // Mandatory logic
    setCountAttributeChange(prev => {
        const newCount = prev + 1;

        let numberOfMandatoryAttributes = 0;
        Object.values(attrList || {}).forEach(attribute => {
            if (attribute.mandatory === "Y") {
                numberOfMandatoryAttributes++;
            }
        });


        if (newCount === numberOfMandatoryAttributes) {
            setCanSubmitDepartmentAttribute(true);
        }

        return newCount;
    });
};

    const handleDepartmentAttributeSubmit = () => {
        debugger;

        let notFilledMandatoryAttributeCount = 0;
        
        attrValList.forEach(item => {
            if(!item.attributeVal || item.attributeVal === '') {
                notFilledMandatoryAttributeCount++;
            }
        });
        if(notFilledMandatoryAttributeCount > 0){
            setSaveDepartmentAttributeSnack(true);
        }
        else{
            //alert("Can be saved");
            
            setSubmitting(true);
            saveDepartmentAttribute().then((res) => {

                /*if (res.id === receiptResponse.receiptDetails.feedback.feedbackId) {


                    setAttrList(res.attributeList);
                    if (res.attributeList.length % 2 === 0) {
                        setIsNumberOfDepartmentAttributesEven(true);
                    }
                    else {
                        setIsNumberOfDepartmentAttributesEven(false);
                    }
                    setCanSubmitDepartmentAttribute(false);
                    // setAttrList(null);
                    setIsDeptAttrSet(true);
                    setDeptAtrSwtich(true);
                    setreadOnlyAttr(true);
                }*/

                setSubmitting(false);
                setDeptAtrSwtich(true);
                setIsDeptAttrSet(false);
                
            });
            
        }
    }

    const parseDataForFeedbackDetails = (data) => {
        console.log(data);
        let retVal = {
            feedbackDetails: {
                feedbackType: {},
                user: {},
                creator: {},
            },
        };
        retVal.feedbackDetails.createDate = data.receiptDetails.feedback.createDate;
        retVal.feedbackDetails.feedbackCode = data.receiptDetails.feedback.feedbackCode;
        retVal.feedbackDetails.feedbackType.description = (data.receiptDetails.feedback.feedbackType.description !== "" && data.receiptDetails.feedback.feedbackType.description != null) ? data.receiptDetails.feedback.feedbackType.description : "N/A";
        retVal.feedbackDetails.feedbackType.id = data.receiptDetails.feedback.feedbackType.id;
        retVal.feedbackDetails.status = data.receiptDetails.feedback.status === 'N' ? 'New' : data.receiptDetails.feedback.status === 'A' ? 'Reopen' : 'N/A';
        retVal.feedbackDetails.feedbackSource = data.receiptDetails.feedback.feedbackSource.description;

        retVal.feedbackDetails.user.orgName = data.receiptDetails.feedback.organizationName;
        retVal.feedbackDetails.user.firstName = data.receiptDetails.feedback.feedbackUserFirstName;
        retVal.feedbackDetails.user.lastName = data.receiptDetails.feedback.feedbackUserLastName;
        retVal.feedbackDetails.user.email = data.receiptDetails.feedback.emailId;
        retVal.feedbackDetails.user.mobile = (data.receiptDetails.feedback.mobileNo !== null) ? (data.receiptDetails.feedback.mobileNo) : 'N/A';
        retVal.feedbackDetails.user.phone = (data.receiptDetails.feedback.feedbackUserPhone !== "") ? (data.receiptDetails.feedback.feedbackUserPhone) : 'N/A';
        retVal.feedbackDetails.user.addressLine = (data.receiptDetails.feedback.addressLine != null) ? (data.receiptDetails.feedback.addressLine) : 'N/A';

        retVal.feedbackDetails.creator.username = data.receiptDetails.feedback.createFirstName + ' ' + data.receiptDetails.feedback.createLastName;

        retVal.feedbackDetails.description = data.receiptDetails.feedback.feedbackDesc;
        setFormData((prevPayload) => ({
            ...prevPayload,
            'feedbackId': data.receiptDetails.feedback.feedbackId,
            // 'receiptTargetId': data.receiptDetails.receipts[0].receiptTargetId,
            // ['departmentId']: data.receiptDetails.feedback.departmentId,
        }));
        setSelectedRow(retVal);
    };
    //{ discardedComment: "",feedbackId: "" }
    const discardFeedbackHandler = (feedbackId) => {
        setOpenDiscardDialog(true);
        setDiscardFeedbackPayload({ discardedComment: "", feedbackId: feedbackId });
    }
    useEffect(() => {
        console.log(discardFeedbackComment, discardFeedbackPayload);
        if (discardFeedbackComment) {
            setDiscardFeedbackPayload((prev) => ({ ...prev, discardedComment: discardFeedbackComment }));
            setReadyToDiscard(true);
        }
        if (readyToDiscard) {
            discardFeedback().then((res) => {
                console.log(res);
                if (res.success === true) {

                    setDiscardFeedbackSuccessSnackbarSwitch(true);
                    discardFeedbackPayload && setDiscardFeedbackPayload((prev) => null);
                    setOpenDiscardDialog(false);
                    setDiscardFeedbackComment(null);
                    setReadyToDiscard(false);
                    //force reload the newfeedbacklist
                    setSpocDeptID((prev) => ({ id: prev.id }));

                }

            });
        }
    }, [discardFeedbackComment, readyToDiscard]);

    const onOldFeedbackChange = (reason, list) => {
        // console.log(value);
        // if (value.length > 0) {
        //     const feedbackCode = value[value.length - 1].feedbackCode;
        //     const feedbackId = value[value.length - 1].feedbackId;
        //     console.log("Inside Old Feedback", feedbackCode);
        //     if (oldFeedbacks.includes(feedbackCode)) {
        //         // If the feedbackCode already exists in oldFeedbacks, remove it
        //         setOldFeedbacks((prev) => prev.filter(code => code === feedbackCode));
        //         setCanTagOF((prev) => (2));
        //     } else {
        //         // If the feedbackCode doesn't exist in oldFeedbacks, add it
        //         setOldFeedbacks((prev) => [...prev, { code: feedbackCode, id: feedbackId }]);
        //         setCanTagOF((prev) => (1));
        //     }

        // }
        // else {
        //     setOldFeedbacks([]);
        //     // setCanTagOF((prev)=>(prev-1));
        // }
        console.log("from add", reason, list);
        list.forEach((value, index) => {

            const feedbackCode = value.feedbackCode;
            const feedbackId = value.feedbackId;
            if (reason === "selectOption") {
                // onValueChange(event, list);
                setOldFeedbacks((prev) => [{ code: feedbackCode, id: feedbackId }]);
                setTagUntag(1); //for tag
                // setSelectedValue((prev)=>[...prev, detail.option]);
            }
            if (reason === "removeOption") {
                // setSelectedValue((prev)=>prev.filter((value)=>value.feedbackCode !== detail.option.feedbackCode));
                setOldFeedbacks((prev) => [{ code: feedbackCode, id: feedbackId }]);
                setTagUntag(2); //for untag

            }
            if (reason === "clear") {
                // setSelectedValue([]);
                setOldFeedbacks([]);
                setTagUntag(0); //for nothing
            }
        })

        setIsOldFeedbackListReady(true);
    }
    const handleTagOldFeedback = () => {
        // let payload = oldFeedbacks.map((item, index) => {
        //     console.log("Inside Tag Old Feedback", item);
        // })
        console.log(oldFeedbacks);
        setTagfeedbackpayload((prev) => ({ ...prev, taggedFeedbackList: oldFeedbacks.map((item, index) => { return { feedbackCode: item.code } }) }))
        tagFeedbackPayload && console.log("Inside Tag Old Feedback", tagFeedbackPayload);
        setIsTagFeedbackReady(true);
        // canTagOF && setCanTagOF((prev) => (prev - (prev + 1)));
    };
    const onSuccessFullAddReceipt = (status) => {
        if (status === true) setReceiptResponse(null);
        else return;
    };
    const closeSnackbarDepartment = () => {
        setDeptAtrSwtich(false);
    }
    const closeSaveDepartmentAttributeSnack = () => {
        setSaveDepartmentAttributeSnack(false);
    }
    const handleTendorChange = (attribute, val) => {
        console.log("From handle Tendor change ", attribute);
        attribute.attributeVal = val;
        setDepartmentAttribute((prev) => {
            return { "id": receiptResponse.receiptDetails.feedback.feedbackId, attributeList: [...prev.attributeList, attribute] };
        });
        // console.log(departmentAttribute);
        console.log("payload----" + val);
        setCountAttributeChange((prev) => (prev + 1));
        // console.log("comapare === ",countAttributeChange+1, Object.values(attrList).length);
        let numberOfMandatoryAttributes = 0;
        Object.values(attrList).forEach((attribute, index) => {
            if (attribute.mandatory === "Y") {
                numberOfMandatoryAttributes++;
            }
        })
        if (countAttributeChange + 1 === numberOfMandatoryAttributes) setCanSubmitDepartmentAttribute(true);
    }
    useEffect(() => {
        
        if (isUsedWithModal) {
            console.log("Inside isUsedWithModal", dataUsedWithModal);
            let deptId = dataUsedWithModal.department.id;
            let feedbackId = dataUsedWithModal.id;
            let status = usedForReopen ? "A" : "N";
            // debugger;
            handlerClick({ departmentId: deptId, feedbackId: feedbackId, status: status });
        }
    }, [isUsedWithModal]);

    useEffect(() => {
        
        if (newFeedbackListResponse) {
            setIsDiscardAllowed(newFeedbackListResponse.isDiscardAllowed);
            const newRowsData = newFeedbackListResponse.feedbackList.map((item, index) => ({
                sl_no: index + 1,
                feedback_code: item.feedbackCode,
                feedback_desc: item.feedbackDesc ? item.feedbackDesc : "N/A",
                org: item.organizationName,
                date: formattedDate(item.createDate),
                status: <TagContainer color={light_theme_bg_grey} status={"New"}></TagContainer>,
                action: <ActionButtonGroup>
                    <button type="button" onClick={() => handlerClick({ departmentId: item.departmentId, feedbackId: item.feedbackId, status: usedForReopen ? "A" : 'N' })}>
                        <IconWrapper icon={addReceipt}></IconWrapper>
                    </button>
                    {isDiscardAllowed && <button type="button" onClick={() => { discardFeedbackHandler(item.feedbackId) }}>
                        <IconWrapper icon={discardIcon}></IconWrapper>
                    </button>}

                </ActionButtonGroup>
            }));

            setRowsData(newRowsData);
        }
        if (openAddReceipt) {
            if(attrList){
                return;
            }
            fetchDetailsforReceiptSPOCURL().then((res) => {
                if (res.success === false) {
                    console.log(res.receiptDetails);
                    return;
                }
                console.log("Inside Details");
                console.log(res);
                setReceiptResponse(res);
                setUserList(res.userList || []);
                setItemData(res.receiptDetails.feedback);
                parseDataForFeedbackDetails(res);
                //debugger;
                //if (res.attributeList.length > 0) {
                if (false) {
                    //we have the attribute list and will render a view only dropdown
                    setreadOnlyAttr(true);
                    setAttrList(res.attributeList);
                    if (res.attributeList.length % 2 === 0) {
                        setIsNumberOfDepartmentAttributesEven(true);
                    }
                    else {
                        setIsNumberOfDepartmentAttributesEven(false);
                    }
                    setIsDeptAttrSet(false);
                }
                else {
                    //we need to fetch department attributes and render a editable dropdown
                    setreadOnlyAttr(false);

                    fetchDepartmentAttributes().then((response) => {
                        if (Object.values(response).length === 0) {
                            console.log(response);
                            setIsDeptAttrSet(false);
                        }
                        else {
                            //console.log("Inside Department Attributes", response);
                            setAttrList(response);

                            const attrMap = res.attributeList.reduce((acc, attr) => {
                                acc[attr.attributeId] = attr.attributeVal;
                                return acc;
                                }, {});

                            
                            let notFilledMandatoryAttributeCount = 0;
                            Object.values(response ?? {}).forEach((attr, index) => {
                                const exists = attrMap.hasOwnProperty(attr.attributeId);
                                if (attr.mandatory === "Y" && !exists) {
                                    notFilledMandatoryAttributeCount++;
                                }
                              
                               if (attr.mandatory === "Y") {
                                    const newAttrVal = {
                                        attributeId: attr.attributeId,
                                        attributeVal: attrMap[attr.attributeId] ?? attr.attributeVal
                                    };
                                    
                                    setAttrValList(prev => [...prev, newAttrVal]);
                                }
                            })

                            
                            if(notFilledMandatoryAttributeCount === 0){
                               setIsDeptAttrSet(false);
                            }

                            if (Object.values(response).length % 2 === 0) {
                                setIsNumberOfDepartmentAttributesEven(true);
                            }
                            else {
                                setIsNumberOfDepartmentAttributesEven(false);
                            }

                            if (Object.values(response).length >= 1) {
                                setCanSubmitDepartmentAttribute(true);
                            }
                            //console.log(response);

                            for (var prop in response) {
                            

                                var attribute = response[prop];
                                attribute.attributeVal = "";
                                for (var thisProp in res.attributeList) {
                                    var thisAttribute = res.attributeList[thisProp];
                                    if(attribute.attributeId === thisAttribute.attributeId){
                                        attribute.attributeVal = thisAttribute.attributeVal;
                                    }
                                    
                                }
                                
                                var tempAttrValList = [];
                                if (attribute.attributeType.toUpperCase() === "LIST") {
                                    const sortedList = [...attribute.attributeMasterValueList].sort((a, b) =>
                                                        a?.attributeVal
                                                            ? a.attributeVal.localeCompare(b?.attributeVal || "")
                                                            : a.attributeVal.localeCompare(b?.attributeVal || "")
                                                        );
                                    console.log("sortedList", sortedList);
                                    sortedList.map((item, index) => (tempAttrValList.push({
                                        departmentAttributeId: item.departmentAttributeId,
                                        departmentAttributeValId: item.departmentAttributeValId,
                                        attributeType: attribute.attributeType,
                                        attributeId: attribute.attributeId,
                                        mandatory: attribute.mandatory,
                                        attributeVal: item.attributeVal,
                                        attributeName: attribute.attributeName,
                                        isspoceditenabled: attribute.isspoceditenabled,
                                        itemIndex : index
                                    
                                    })));
                                }

                                attribute.attributeMasterValueList = tempAttrValList;

                                attribute.selectedItem = tempAttrValList.find(
                                                        item => item.attributeVal === attribute.attributeVal
                                                        )?.itemIndex;

                            }
                            console.log("response--->" + JSON.stringify(response));

                        }
                    }
                    );


                }

                setTagfeedbackpayload((prev) => ({ ...prev, departmentId: res.receiptDetails.feedback.departmentId, feedbackId: res.receiptDetails.feedback.id, feedback: { userId: res.receiptDetails.feedback.bidderId }, taggedFeedbackList: {} }));
            });
            // if (tagFeedbackPayload && tagFeedbackPayload.taggedFeedbackList?.length > 0) {
            //     tagFeedback().then((res) => { alert(res?.responseDetails) });
            // }
            // if(isOldFeedbackListReady){
            //     console.log("Inside Old Feedback List Ready");
            //     handleTagOldFeedback();
            //     isOldFeedbackListReady && setIsOldFeedbackListReady(false);
            // }
            // if(isTagFeedbackReady){
            //     console.log("Inside Tag Feedback Ready");
            //     if(tagUntag === 1){

            //     tagFeedback().then((res) => { alert(res?.responseDetails) });
            //     }
            //     setIsTagFeedbackReady(false);
            // }
        }
    }, [fetchDepartmentAttributes, fetchDetailsforReceiptSPOCURL, newFeedbackListResponse, openAddReceipt, receiptFetchPayload, canSubmitDepartmentAttribute, receivedOldFeedback, isOldFeedbackListReady, isTagFeedbackReady, tagUntag]);

                const handleUpdateFeedbackUser = () => {
                    if (
                        receiptResponse?.receiptDetails?.feedback?.bidderId !== 0 ||
                        !selectedUserId
                    ) {
                        return Promise.resolve();
                    }

                    return updateFeedbackUser().then((res) => {
                            console.log("Update Feedback User Response:", res);

                            if (res?.success !== true) {
                                throw new Error("Failed to update feedback user");
                            }

                            setReceiptResponse(prev => ({
                                ...prev,
                                receiptDetails: {
                                    ...prev.receiptDetails,
                                    feedback: {
                                        ...prev.receiptDetails.feedback,
                                        bidderId: selectedUserId
                                    }
                                }
                            }));
                                setSnackbarMessage("User tagged successfully");
                                setAddReceiptSnackbarSwitch(true);
                            return res;
                        });
                };

    return (
        <>
            {/* <div className='wrapper'>
            <Container fluid> */}
            {!isUsedWithModal && path && <PageHeadContainer pathArray={path} pageTitle={path[path.length - 1]}></PageHeadContainer>}
            {!isUsedWithModal && !openAddReceipt && rowsData && rowsData.length > 0 && <DatatTable tableStyles={tableStyles} tableData={{ columnData: columnData, rowsData: rowsData }}></DatatTable>}
            {!isUsedWithModal && !openAddReceipt && <UntagFeedbackDialog open={openDiscardDialog} setOpen={setOpenDiscardDialog} returnComment={setDiscardFeedbackComment} />}
            {!isUsedWithModal && openAddReceipt && !disableReceiptView && <ViewFeedbackDetails fetchUrl={API_Routes.getDetailsforReceiptSPOCURL} body={receiptFetchPayload}></ViewFeedbackDetails>}
            {openAddReceipt && !disableReceiptView &&
                <>

                    {!isUsedWithModal &&
                        <Card.Header className='light-blue-bg'>
                            {t('general.message.additional.info.panel.header')}
                        </Card.Header>
                    }

                    <>
                        {/* <Row> */}

                         {
                receiptResponse?.receiptDetails?.feedback?.bidderId === 0 && (
                    <Row className="mb-3">
                    <Col lg="12">
                            <label className="form-label">
                                     Select an User to tag <span style={{ color: "red" }}>*</span>
                            </label>
                    </Col>
                            <Col lg="12">
                            <div className="table-responsive">
                        <table className="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>Select</th>
                                    <th>Feedback Count</th>
                                    <th>Organization</th>
                                    <th>Email</th>
                                    <th>Phone</th>
                                    {/* <th>Mobile</th> */}
                                </tr>
                            </thead>

                            <tbody>
                                {userList.map((user) => (
                                    <tr key={user.bidderId}>
                                        <td>
                                            <input
                                                type="radio"
                                                name="selectedUser"
                                                value={user.bidderId}
                                                checked={selectedUserId === user.bidderId}
                                                onChange={() => setSelectedUserId(user.bidderId)}
                                            />
                                        </td>

                                        <td>{user.feedbackCount || 0}</td>

                                        <td>{user.bidderOrgName || "-"}</td>

                                        <td>{user.emailId || "-"}</td>

                                        <td>{user.phone || "-"}</td>

                                        {/* <td>{user.mobile || "-"}</td> */}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                            <div className="mt-2">
                                <Button
                                    variant="primary"
                                    onClick={handleUpdateFeedbackUser}
                                    disabled={!selectedUserId}
                                >
                                    Tag User
                                </Button>
                            </div>
                        </Col>
                    </Row>
                )
                }

                        {/* department attributes start */}
                        {true &&
                            <Row>
                                {attrList &&
                                    Object.values(attrList).map((attribute, index) =>
                                        <Col lg="6" className='mb-3'>
                                            <FormRow key={index}>

                                                <TextLabel
                                                    title={attribute.attributeName} 
                                                    isMandatory={attribute.mandatory ? true : false}
                                                ></TextLabel>
                                                 
                                                <HorizontalContainer>
                                                    {readOnlyAttr &&
                                                        // <ReadOnlyTextField value={attribute.attributeVal} />
                                                        <Form.Control type="text" placeholder={attribute.attributeVal} readOnly />
                                                    }
                                                    {/*!readOnlyAttr && attribute.attributeType === "LIST" && attribute.isspoceditenabled === "N" &&
                                                        <Dropdown keyIdentifier={attribute.attributeId} isDisabled={true} selectedItem={String(attribute.selectedItem)} isMandatory={attribute.mandatory ? true : false} onChange={handleClientChange} items={attribute.attributeMasterValueList}></Dropdown>
                                                    */}
                                                    {!readOnlyAttr && attribute.attributeType === "LIST" &&
                                                        <Dropdown keyIdentifier={attribute.attributeId} isDisabled={readOnlyAttr} selectedItem={String(attribute.selectedItem)} isMandatory={attribute.mandatory ? true : false} onChange={handleClientChange} items={attribute.attributeMasterValueList}></Dropdown>
                                                    }
                                                    {!readOnlyAttr && attribute.attributeType === "DATE" &&
                                                        <DatePickerComponent key={attribute.attributeVal} isMandatory={true} width={'-webkit-fill-available'} defaultValue={attribute.attributeVal? moment(attribute.attributeVal, "DD-MM-YYYY"): null} attribute={attribute} onChange={(date) => handleClientChange({ attributeVal: date }, attribute.attributeId) }/>
                                                    }
                                                    {!readOnlyAttr && attribute.attributeType === "text" &&
                                                        <Form.Control
                                                            as="input"
                                                            type="text"
                                                            rows={3}
                                                            value={attribute.attributeVal || ""}
                                                            placeholder={`Enter ${attribute.attributeName}`}
                                                            onChange={(e) => handleTendorChange(attribute, e.target.value)}
                                                        />
                                                    }

                                                </HorizontalContainer>
                                            </FormRow>
                                        </Col>

                                    )
                                }
                                {canSubmitDepartmentAttribute && receiptResponse?.receiptDetails?.feedback?.bidderId !== 0 && (
                                    <SmallBottomNegativeMargin>
                                        <SmallFormSubmitButton buttonText= {submitting ? "Saving..." : "Save"} onClickHandler={handleDepartmentAttributeSubmit} disabled={submitting} />
                                    </SmallBottomNegativeMargin>
                                   
                                )}
                            </Row>

                        }
                        {/*!isNumberOfDepartmentAttributesEven &&
                            <>
                                {attrList &&
                                    <Row>
                                        <Col lg="12" className='mb-3'>

                                            <TextLabel
                                                title={Object.values(attrList)[0].attributeName}
                                                isMandatory={Object.values(attrList)[0].mandatory ? true : false}
                                            ></TextLabel>
                                            <HorizontalContainer>
                                                {readOnlyAttr &&
                                                    // <ReadOnlyTextField value={Object.values(attrList)[0].attributeVal} />
                                                    <Form.Control type="text" placeholder={Object.values(attrList)[0].attributeVal} readOnly />
                                                }
                                                {!readOnlyAttr && Object.values(attrList)[0].attributeType === "LIST" &&
                                                    <Dropdown isDisabled={readOnlyAttr} initVal={readOnlyAttr ? Object.values(attrList)[0].attributeVal : ""} isMandatory={Object.values(attrList)[0].mandatory ? true : false} onChange={handleClientChange} items={Object.values(attrList)[0].attributeMasterValueList}></Dropdown>
                                                }
                                                {!readOnlyAttr && Object.values(attrList)[0].attributeType === "DATE" && <></>
                                                    // <DatePickerComponent isMandatory={true} width={'-webkit-fill-available'} attribute={attribute} onChange={(e) => handleClientChange(e, attribute)}></DatePickerComponent>
                                                }
                                                {!readOnlyAttr && Object.values(attrList)[0].attributeType === "text" &&
                                                    <Form.Control
                                                        as="input"
                                                        type="text"
                                                        rows={3}
                                                        placeholder={`Enter ${Object.values(attrList)[0].attributeName}`}
                                                        onChange={(e) => handleTendorChange(Object.values(attrList), e.target.value)}
                                                    />}

                                            </HorizontalContainer>

                                        </Col></Row>}
                                <Row>
                                    {attrList &&

                                        Object.values(attrList).map((attribute, index) => {
                                            if (index === 0) {
                                                return <></>;
                                            }
                                            else {
                                                return (
                                                    <Col lg="6">

                                                        <FormRow key={index}>
                                                            <TextLabel
                                                                title={attribute.attributeName}
                                                                isMandatory={attribute.mandatory ? true : false}
                                                            ></TextLabel>
                                                            <HorizontalContainer>
                                                                {readOnlyAttr &&
                                                                    // <ReadOnlyTextField value={attribute.attributeVal} />
                                                                    <Form.Control type="text" placeholder={attribute.attributeVal} readOnly />
                                                                }
                                                                {!readOnlyAttr && attribute.attributeType === "LIST" &&
                                                                    <Dropdown isDisabled={readOnlyAttr} initVal={readOnlyAttr ? attribute.attributeVal : ""} isMandatory={attribute.mandatory ? true : false} onChange={handleClientChange} items={attribute.attributeMasterValueList}></Dropdown>
                                                                }
                                                                {!readOnlyAttr && attribute.attributeType === "DATE" &&
                                                                    <DatePickerComponent isMandatory={true} width={'-webkit-fill-available'} value={attribute.attributeVal}  attribute={attribute} onChange={(date) => handleClientChange({ attributeVal: date },attribute.attributeId)}></DatePickerComponent>
                                                                }
                                                                {!readOnlyAttr && attribute.attributeType === "text" &&
                                                                    <Form.Control
                                                                        as="input"
                                                                        type="text"
                                                                        rows={3}
                                                                        placeholder={`Enter ${attribute.attributeName}`}
                                                                        onChange={(e) => handleTendorChange(attribute, e.target.value)}
                                                                    />}

                                                            </HorizontalContainer>
                                                        </FormRow>
                                                    </Col>
                                                );
                                            }

                                        }



                                        )
                                    }
                                </Row>

                                {canSubmitDepartmentAttribute && (
                                    <SmallBottomNegativeMargin>
                                        <SmallFormSubmitButton buttonText={"SAVE"} onClickHandler={handleDepartmentAttributeSubmit} />

                                    </SmallBottomNegativeMargin>
                                )}
                            </>
                        */}
                        {/* <Col lg="6">
                                    {attrList &&
                            Object.values(attrList).map((attribute, index) =>

                                <FormRow key={index}>
                                    <TextLabel
                                        title={attribute.attributeName}
                                        isMandatory={attribute.mandatory ? true : false}
                                    ></TextLabel>
                                    <HorizontalContainer>
                                        {readOnlyAttr &&
                                            <ReadOnlyTextField value={attribute.attributeVal} />
                                        }
                                        {!readOnlyAttr && attribute.attributeType === "LIST" &&
                                            <Dropdown isDisabled={readOnlyAttr} initVal={readOnlyAttr ? attribute.attributeVal : ""} isMandatory={attribute.mandatory ? true : false} onChange={handleClientChange} items={attributeMasterValueList}></Dropdown>
                                        }
                                        {!readOnlyAttr && attribute.attributeType === "DATE" &&
                                            <DatePickerComponent isMandatory={true} width={'-webkit-fill-available'} onChangeAddFeedback={handleClientChange}></DatePickerComponent>
                                        }

                                    </HorizontalContainer>
                                </FormRow>


                            )
                        }
                        {canSubmitDepartmentAttribute && (
                            <SmallBottomNegativeMargin>
                                <SmallFormSubmitButton buttonText={"SAVE"} onClickHandler={handleDepartmentAttributeSubmit} />

                            </SmallBottomNegativeMargin>
                        )}
                                </Col> */}

                        {/* department attributes start */}


                        {receiptResponse && (<>
                        

                            <Col lg="12">

                                <TextLabel title={t('general.lebel.tagOldFeedback')} />
                                {receiptResponse && <TagOldFeedback id={spocDeptID.id} feedbackId={receiptResponse.receiptDetails.feedback.feedback_id} url={`${apiHostUrl}${homeLink}${getOldFeedbackSPOCUrl}`} feedbackBidderId={receiptResponse.receiptDetails.feedback.bidderId} oldFeedbackValueChange={onOldFeedbackChange} taggedFeedbackList={receiptResponse.receiptDetails.taggedFeedbackList}></TagOldFeedback>}

                                {/* <FormRow>
                            {canTagOF > 0 && (
                                <SmallFormSubmitButton buttonText={canTagOF > 1 ? "UNTAG" : "TAG"} onClickHandler={handleTagOldFeedback} />
                            )}
                        </FormRow> */}
                            </Col>




                            {selectedRow && receiptResponse && !isDeptAttrSet &&
                                (<SLAContainer style={{ marginTop: "1rem" }}
                                    deptId={spocDeptID.id}
                                    feedbackId={receiptResponse.receiptDetails.feedback.id}
                                    feedbackTypeId={selectedRow.feedbackDetails.feedbackType.id}
                                    conditionList={receiptResponse.receiptDetails.conditionList}
                                    feedbackTypeList={receiptResponse.receiptDetails.feedbackTypeList}
                                    status={receiptResponse.receiptDetails.feedback.status}
                                    bidderId={receiptResponse.receiptDetails.feedback.bidderId}
                                    oldFeedbackList={oldFeedbacks}
                                    onSuccessFullAddReceipt={onSuccessFullAddReceipt}
                                    toggleAddReceiptSnackbarSwitch={snackBarSwitch}
                                    setSnackbarMessage={snackMsg}
                                    disableReceiptViewHandler={setDisableReceiptView}
                                    setItemData={setFormData}
                                    onModalCloseHandler={onModalCloseHandler}
                                    parentModalOnClose={parentModalOnClose}
                                    scoopDataForChild={scoopDataForChild}
                                    modalSwitchHandler={modalSwitchHandler}
                                    fdHandler={fdHandler ? fdHandler : null}
                                    handleUpdateFeedbackUser={handleUpdateFeedbackUser}
                                />)
                            }

                        </>)}


                        {/* </Row> */}
                    </>
                </>
            }
            {disableReceiptView &&
                <>
                    <ViewFeedbackDetailsForClose
                        fetchUrl={API_Routes.getFeedbackDetailsforFeedbackCloseURL}
                        body={formData}
                        keyComponent={"Close"}
                        renderComponent={(val) => <FeedbackClosure itemData={itemData} receiptTargetId={formData.receiptTargetId} uploadFormData={val} />}
                    />
                </>
            }
            <PluginSnackbar open={deptAtrSwtich} message={t("alert.msg.department.attribute")} onClose={closeSnackbarDepartment} />
            <PluginSnackbar open={addReceiptSnackbarSwitch} message={snackbarMessage} onClose={toggleAddReceiptSnackbarSwitch} />
            <PluginSnackbar open={discardFeedbackSuccessSnackbarSwitch} message={t("alert.msg.discard.feedback.success")} onClose={() => { setDiscardFeedbackSuccessSnackbarSwitch(false) }} />
            <PluginSnackbar open={saveDepartmentAttributeSnack} message={t("alert.msg.department.attribute.fail")} onClose={closeSaveDepartmentAttributeSnack} />
            {/* </Container>
        </div> */}
        </>
    )
}